// AlvaniumMainContent.js
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./Maincontent.css";
import backgroundImage from "../src/icons/backgroundImage.png";
import Header from "./Header";
import Footer from "./Footer";
import workflowIcon from "./icons/workflowIcon.png";
import teamProductivity from "./icons/teamProductivity.png";
import platformCustomizationIcon from "./icons/platformCustomizationIcon.png";
import innovationIcon from "./icons/innovationIcon.png";
import securityShield from "./icons/securityShield.png";
import responsiveIcon from "./icons/responsive.png";
import editPropertyIcon from "./icons/editPropertyIcon.png";
import laptopIcon from "./icons/laptopIcon.png";
import growthIcon from "./icons/growthIcon.png";
import supportIcon from "./icons/supportIcon.png";
import flowchartIcon from "./icons/flowchartIcon.png";
import targetAudienceIcon from "./icons/targetAudienceIcon.png";
import jira from "./icons/jira.png";
import Confluence from "./icons/Confluence.png";
import JiraService from "./icons/Jira-Service-Management.png";
import zendesk from "./icons/zendesk copy.png";
import monday from "./icons/monday.png";
import AndroidLogo from "./icons/phone.png";
import Android from "./icons/android2.png";
import GearIcon from "./icons/gearIcon.png";

function AlvaniumMainContent() {
  const navigate = useNavigate();
  const whyGridRef = useRef(null);

  // Navigation handlers
  const handleNavigation = (path) => {
    navigate(path);
  };

  useEffect(() => {
    const cards = whyGridRef.current
      ? whyGridRef.current.querySelectorAll(".alv-why-card")
      : [];

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("alv-why-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    cards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  return (
    <>
      {/* Hero Section */}
      <Header />
      <section className="alv-hero">
        <div className="alv-hero-background">
          <div className="alv-orb alv-orb1"></div>
          <div className="alv-orb alv-orb2"></div>
          <div className="alv-orb alv-orb3"></div>
        </div>

        <div className="alv-hero-content">
          {/* <div className="alv-hero-badge">
            Smart Solutions
          </div> */}

          <h1>
            Intelligence Behind <br />
         <span className="alv-gradient-text">Every Workflow</span>
          </h1>

          <p className="alv-sub-head">
            Custom Software, Android Apps, and Business Platform Solutions Built for Growth.
          </p>

          <p className="alv-desc">
            We help businesses streamline workflows with custom software development,
            Android app development, and tailored business platform solutions that enhance
            efficiency and productivity.
          </p>

          <div className="alv-hero-buttons">
            <button 
              className="alv-primary-btn" 
              onClick={() => handleNavigation('/contact')}
            >
              <span>Get Started</span>
              <i className="fas fa-arrow-right"></i>
            </button>

            <button 
              className="alv-secondary-btn" 
              onClick={() => handleNavigation('/products')}
            >
              <i className="fas fa-play-circle"></i>
              Explore Solutions
            </button>
          </div>
        </div>

        <div className="alv-hero-visual">
          <div className="alv-floating-cards">
            <div className="alv-float-card alv-card-analytics">
              <div className="alv-card-icon">📊</div>
              <div className="alv-card-content">
                <h4>Smart Insights</h4>
                <div className="alv-progress-bar">
                  <div className="alv-progress-fill" style={{ width: "95%" }}></div>
                </div>
                <span className="alv-progress-label">95% Performance</span>
              </div>
            </div>

            <div className="alv-float-card alv-card-android">
              <div className="alv-card-icon">📱</div>
              <div className="alv-card-content">
                <h4>Android Apps</h4>
                <div className="alv-feature-tags">
                  <span>Custom</span>
                  <span>Scalable</span>
                  <span>Secure</span>
                </div>
              </div>
            </div>

            <div className="alv-float-card alv-card-collab">
              <div className="alv-card-icon">🤝</div>
              <div className="alv-card-content">
                <h4>Team Collaboration</h4>
                <div className="alv-collab-indicators">
                  <span className="alv-dot alv-active"></span>
                  <span className="alv-dot alv-active"></span>
                  <span className="alv-dot"></span>
                  <span className="alv-dot alv-active"></span>
                  <span className="alv-dot"></span>
                  <span className="alv-status-text">Real-Time Updates</span>
                </div>
              </div>
            </div>
          </div>

          <div className="alv-floating-shapes">
            <div className="alv-shape alv-shape1"></div>
            <div className="alv-shape alv-shape2"></div>
            <div className="alv-shape alv-shape3"></div>
          </div>
        </div>
      </section>

      {/* Trusted Solutions */}
      <section className="alv-section alv-trusted-soltions">
        <div className="alv-section-head">
          {/* <div className="alv-hero-badge">
  <span className="alv-pulse-dot"></span>
  Smart Solutions
</div> */}
        <h2>
  Solutions Designed For{" "}
  <span className="alv-gradient-text">
    Modern Businesses
  </span>
</h2>

          <p>
            We provide custom software development, Android app development,
            and digital solutions that streamline workflows, improve productivity,
            and help businesses grow.
          </p>
        </div>

        <div className="alv-solutions-grid">
          <div className="alv-solution-card">
            <div className="alv-card-pattern"></div>
            <div className="alv-app-icon">
              <img src={workflowIcon} alt="Workflow" className="alv-app-icon-img" />
            </div>
            <h3>Workflow Optimization</h3>
            <p>Improve process efficiency through intelligent workflows and automation.</p>
          </div>

          <div className="alv-solution-card">
            <div className="alv-card-pattern"></div>
            <div className="alv-card-icon-wrap">
              <div className="alv-icon-box">
                <img src={teamProductivity} alt="Business Productivity" className="alv-icon-img" />
              </div>
            </div>
            <h3>Business Productivity</h3>
            <p>Create systems that simplify daily operations and team collaboration.</p>
          </div>

          <div className="alv-solution-card">
            <div className="alv-card-pattern"></div>
            <div className="alv-card-icon-wrap">
              <div className="alv-icon-box">
                <img src={platformCustomizationIcon} alt="Platform Customization" className="alv-card-icon-img" />
              </div>
            </div>
            <h3>Platform Customization</h3>
            <p>Build personalized configurations tailored to unique business requirements.</p>
          </div>

          <div className="alv-solution-card">
            <div className="alv-card-pattern"></div>
            <div className="alv-card-icon-wrap">
              <div className="alv-icon-box">
                <img src={innovationIcon} alt="Scalable Solutions" className="alv-card-icon-img" />
              </div>
            </div>
            <h3>Scalable Solutions</h3>
            <p>Build flexible systems designed for future business growth.</p>
          </div>
        </div>
      </section>

      {/* About */}
      <section className="alv-section alv-about-preview">
        <div className="alv-about-container">
          <div className="alv-about-visual">
            <div className="alv-about-image-card">
              <div className="alv-about-image-wrapper">
                <img src={backgroundImage} alt="Team collaboration" className="alv-about-image" />
              </div>
            </div>
          </div>

          <div className="alv-about-content">
            {/* <span className="alv-badge">Who We Are</span> */}
            <h2>
              Building the <span className="alv-gradient-text">Future of Work</span>
            </h2>
            <p>
              Alvanium is a technology-focused company dedicated to
              delivering powerful and scalable digital solutions.
            </p>

            <div className="alv-about-timeline">
              <div className="alv-timeline-item">
                <div className="alv-timeline-dot"></div>
                <div className="alv-timeline-content">
                  <h4>Innovation First</h4>
                  <p>We work with organizations to simplify workflows and improve collaboration.</p>
                </div>
              </div>

              <div className="alv-timeline-item">
                <div className="alv-timeline-dot"></div>
                <div className="alv-timeline-content">
                  <h4>Custom Solutions</h4>
                  <p>Create customized technology experiences that align with business goals.</p>
                </div>
              </div>

              <div className="alv-timeline-item">
                <div className="alv-timeline-dot"></div>
                <div className="alv-timeline-content">
                  <h4>Smarter Operations</h4>
                  <p>Help businesses operate smarter and grow faster with our systems.</p>
                </div>
              </div>
            </div>

            <button 
              className="alv-primary-btn" 
              onClick={() => handleNavigation('/aboutalvanium')}
            >
              About Alvanium
            </button>
          </div>
        </div>
      </section>

      {/* Products & Services */}
      <section className="alv-section alv-products-services">
        <div className="alv-section-head">
          {/* <span className="alv-badge">
            <i className="fas fa-cube"></i> Products &amp; Services
          </span> */}
          <h2>
            Our <span className="alv-gradient-text">Products &amp; Services</span>
          </h2>
          <p>Explore our solutions designed to improve team collaboration and business productivity.</p>
        </div>

        <div className="alv-products-grid">
          <div className="alv-product-card">
            <div className="alv-product-icon">
              <img src={jira} alt="Jira" className="alv-product-logo" />
            </div>
            <h3>Jira App Development</h3>
            <p>Build custom Jira apps and plugins to extend functionality and improve workflows.</p>
          </div>

          <div className="alv-product-card">
            <div className="alv-product-icon">
              <img src={Confluence} alt="Confluence" className="alv-product-logo" />
            </div>
            <h3>Confluence App Development</h3>
            <p>Develop custom Confluence apps that enhance collaboration and knowledge management.</p>
          </div>

          <div className="alv-product-card">
            <div className="alv-product-icon">
              <img src={JiraService} alt="Jira Service Management" className="alv-product-logo" />
            </div>
            <h3>Jira Service Management App Development</h3>
            <p>Create custom JSM apps to improve service management and support workflows.</p>
          </div>

          <div className="alv-product-card">
            <div className="alv-product-icon">
              <img src={zendesk} alt="zendesk" className="alv-product-logo" />
            </div>
            <h3>Zendesk App Development</h3>
            <p>Build custom Zendesk apps that enhance customer support and team productivity.</p>
          </div>

          <div className="alv-product-card">
            <div className="alv-product-icon">
              <img src={monday} alt="monday.com" className="alv-product-logo" />
            </div>
            <h3>monday.com App Development</h3>
            <p>Develop custom Monday.com apps to streamline project and work management.</p>
          </div>

          <div className="alv-product-card">
            <div className="alv-product-icon">
              <img src={AndroidLogo} alt="Android" className="alv-product-logo" />
            </div>
            <h3>Android App Development</h3>
            <p>Build scalable Android applications tailored to your business requirements.</p>
          </div>

          <div className="alv-product-card">
            <div className="alv-product-icon">
              <img src={GearIcon} alt="Custom Software" className="alv-product-logo" />
            </div>
            <h3>Custom Software Development</h3>
            <p>Design and develop scalable software solutions for unique business needs.</p>
          </div><div className="alv-product-card">
            <div className="alv-product-icon">
              <img src={Android} alt="Android" className="alv-product-logo" />
            </div>
            <h3>Android Custom App Development</h3>
            <p>Build secure, high-performance Android applications tailored to your business processes and user needs.</p>
          </div>
        </div>
      </section>

      {/* Android Highlight */}
      <section className="alv-section alv-android-highlight">
        <div className="alv-android-container">
          <div className="alv-android-content">
            {/* <span className="alv-badge">
              <i className="fas fa-mobile-alt"></i> Android Development
            </span> */}
            <h2>
              Custom Android Applications <span className="alv-gradient-text">Built For Growth</span>
            </h2>
            <p>
              Alvanium creates secure, scalable, and user-friendly Android
              applications designed to meet specific business requirements.
            </p>

            <div className="alv-feature-grid">
              <div className="alv-feature-item">
                <div className="alv-feature-icon">⚡</div>
                <div>
                  <h4>Fast Performance</h4>
                  <p>Optimized for speed and responsiveness</p>
                </div>
              </div>

              <div className="alv-feature-item">
                <div className="alv-feature-icon">
                  <img src={responsiveIcon} alt="Responsive Design" className="alv-feature-icon-img" />
                </div>
                <div>
                  <h4>Modern UI Design</h4>
                  <p>Intuitive and engaging user experiences</p>
                </div>
              </div>

              {/* <div className="alv-feature-item">
                <div className="alv-feature-icon">🔗</div>
                <div>
                  <h4>API Integration</h4>
                  <p>Seamless connection with your systems</p>
                </div>
              </div> */}

              <div className="alv-feature-item">
                <div className="alv-feature-icon">
                  <img src={securityShield} alt="Security" className="alv-feature-icon-img" />
                </div>
                <div>
                  <h4>Secure Architecture</h4>
                  <p>Enterprise-grade security standards</p>
                </div>
              </div>

              <div className="alv-feature-item">
                <div className="alv-feature-icon">📈</div>
                <div>
                  <h4>Easy Scalability</h4>
                  <p>Grow with your business needs</p>
                </div>
              </div>
            </div>

            <button 
              className="alv-primary-btn" 
              onClick={() => handleNavigation('/android')}
            >
              <i className="fas fa-android"></i>
              Explore Android Solutions
            </button>
          </div>

          <div className="alv-android-visual">
            <div className="alv-phone-mockup alv-phone1">
              <div className="alv-phone-notch"></div>
              <div className="alv-phone-screen">
                <div className="alv-app-icon-grid">
                  <div className="alv-app-icon" style={{ background: "#2a6df4" }}>📊</div>
                  <div className="alv-app-icon" style={{ background: "#1a4fa8" }}>📱</div>
                  <div className="alv-app-icon" style={{ background: "#3b82f6" }}>⚙</div>
                  <div className="alv-app-icon" style={{ background: "#60a5fa" }}>📈</div>
                </div>
                <div className="alv-screen-bar"></div>
                <div className="alv-screen-bar alv-short"></div>
              </div>
            </div>

            <div className="alv-phone-mockup alv-phone2">
              <div className="alv-phone-notch"></div>
              <div className="alv-phone-screen">
                <div className="alv-screen-bar"></div>
                <div className="alv-screen-bar alv-short"></div>
                <div className="alv-screen-block"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose */}
      <section className="alv-section alv-why-choose">
        <div className="alv-section-head">
          {/* <span className="alv-badge">
            <i className="fas fa-heart"></i> Why Alvanium
          </span> */}
          <h2>
            Why Choose <span className="alv-gradient-text">Alvanium</span>
          </h2>
        </div>

        <div className="alv-why-grid" ref={whyGridRef}>
          <div className="alv-why-card">
            {/* <div className="alv-why-number">01</div> */}
            <div className="alv-why-icon">
              <img src={flowchartIcon} alt="Development Process" className="alv-why-icon-img" />
            </div>
            <h3>Smart Solutions</h3>
            <p>Create efficient systems that reduce complexity.</p>
          </div>

          <div className="alv-why-card">
            {/* <div className="alv-why-number">02</div> */}
            <div className="alv-why-icon">
              <img src={editPropertyIcon} alt="Edit Property" className="alv-why-icon-img" />
            </div>
            <h3>Customized Approach</h3>
            <p>Build solutions tailored for specific business requirements.</p>
          </div>

          <div className="alv-why-card">
            {/* <div className="alv-why-number">03</div> */}
            <div className="alv-why-icon">
              <img src={growthIcon} alt="Growth" className="alv-why-icon-img" />
            </div>
            <h3>Scalable Technology</h3>
            <p>Develop systems designed for future growth.</p>
          </div>

          <div className="alv-why-card">
            {/* <div className="alv-why-number">04</div> */}
            <div className="alv-why-icon">
              <img src={supportIcon} alt="Reliable Support" className="alv-why-icon-img" />
            </div>
            <h3>Reliable Support</h3>
            <p>Ensure continuous assistance and improvements.</p>
          </div>

          <div className="alv-why-card">
            {/* <div className="alv-why-number">05</div> */}
            <div className="alv-why-icon">
              <img src={targetAudienceIcon} alt="Target Audience" className="alv-why-icon-img" />
            </div>
            <h3>User-Focused Design</h3>
            <p>Deliver smooth and intuitive experiences.</p>
          </div>

          <div className="alv-why-card">
            {/* <div className="alv-why-number">06</div> */}
            <div className="alv-why-icon">
              <img src={laptopIcon} alt="Technology" className="alv-why-icon-img" />
            </div>
            <h3>Modern Technologies</h3>
            <p>Build with updated technologies and industry practices.</p>
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="alv-section alv-process">
        <div className="alv-section-head">
          {/* <span className="alv-badge">
            <i className="fas fa-route"></i> Our Process
          </span> */}
          <h2>
            How <span className="alv-gradient-text">We Work</span>
          </h2>
        </div>

        <div className="alv-process-container">
          <div className="alv-process-step">
            <div className="alv-step-number">1</div>
            <div className="alv-step-content">
              <h3>Understand Requirements</h3>
              <p>We analyze business goals and requirements.</p>
            </div>
            <div className="alv-step-connector"></div>
          </div>

          <div className="alv-process-step">
            <div className="alv-step-number">2</div>
            <div className="alv-step-content">
              <h3>Plan &amp; Design</h3>
              <p>Create solution structures and user experience designs.</p>
            </div>
            <div className="alv-step-connector"></div>
          </div>

          <div className="alv-process-step">
            <div className="alv-step-number">3</div>
            <div className="alv-step-content">
              <h3>Develop &amp; Customize</h3>
              <p>Build and customize solutions based on needs.</p>
            </div>
            <div className="alv-step-connector"></div>
          </div>

          <div className="alv-process-step">
            <div className="alv-step-number">4</div>
            <div className="alv-step-content">
              <h3>Deploy &amp; Support</h3>
              <p>Launch solutions and provide ongoing support.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="alv-section alv-testimonials">
        <div className="alv-section-head">
          {/* <span className="alv-badge">
            <i className="fas fa-quote-left"></i> Testimonials
          </span> */}
          <h2>
            What Our <span className="alv-gradient-text">Clients Say</span>
          </h2>
        </div>

        <div className="alv-testimonials-grid">
          <div className="alv-testimonial-card">
            <div className="alv-quote-mark">"</div>
            <div className="alv-stars">★★★★★</div>
            <p>
              "Alvanium helped us simplify our workflow process and improve productivity
              significantly. Their team understood our needs perfectly."
            </p>
          </div>

          <div className="alv-testimonial-card">
            <div className="alv-quote-mark">"</div>
            <div className="alv-stars">★★★★★</div>
            <p>
              "The customization and support experience was smooth and efficient. They
              delivered exactly what we needed, on time and within budget."
            </p>
          </div>

          <div className="alv-testimonial-card">
            <div className="alv-quote-mark">"</div>
            <div className="alv-stars">★★★★★</div>
            <p>
              "Their solutions helped our teams collaborate more effectively across
              departments. The Android app they built transformed our operations."
            </p>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="alv-section alv-contact-cta">
        <div className="alv-cta-container">
          <div className="alv-cta-content">
            <h2>
              Ready to Build
              <span className="alv-gradient-text"> Your Next Custom App? </span>
            </h2>

            <p>
              We develop custom apps, software, and digital solutions that help businesses
              work smarter and grow faster.
            </p>

            <div className="alv-cta-buttons">
              {/* <button 
                className="alv-cta-btn alv-primary-btn" 
                onClick={() => handleNavigation('/contact')}
              >
                <span>Get Started</span>
                <i className="fas fa-arrow-right"></i>
              </button> */}

              <button 
                className="alv-cta-btn alv-secondary-btn" 
                onClick={() => handleNavigation('/contact')}
              >
                <i className="fas fa-comments"></i>
                <span>Contact Us</span>
              </button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      
    </>
  );
}

export default AlvaniumMainContent;